/** Registration / account-setup paths where cross-portal logout should not interrupt local flows. */
export function isAuthRegistrationPath(pathname: string): boolean {
  return (
    pathname === '/account-setup' ||
    pathname === '/registration/account-setup' ||
    pathname.startsWith('/registration') ||
    pathname === '/choose-role'
  );
}
